const URGENCY = [[0.75, "Urgent", "bg-[#FF3B3B]/15 text-[#C81E1E]"], [0.5, "High", "bg-amber-500/15 text-amber-700"], [0.25, "Medium", "bg-sky-500/15 text-sky-700"], [0, "Low", "bg-slate-100 text-slate-600"]];
const FIT = [[0.75, "Strong", "bg-emerald-500/15 text-emerald-700"], [0.5, "Good", "bg-teal-500/15 text-teal-700"], [0.25, "Fair", "bg-amber-500/15 text-amber-700"], [0, "Weak", "bg-slate-100 text-slate-600"]];
const OK = "bg-emerald-500/15 text-emerald-700";
const WARN = "bg-[#FF3B3B]/15 text-[#C81E1E]";
const PLAIN = "bg-[#0F766E]/10 text-[#0F766E]";

export const human = (s) => (s || "").replace(/_/g, " ").replace(/^\w/, (c) => c.toUpperCase());
const band = (bands, v) => bands.find(([min]) => v >= min);

// Text + colour for one Jev tag; "Unsorted" when Jev could not decide.
export const aiTag = (ai, kind) => {
  const a = ai || {};
  if (kind === "caption") {
    if (a.flagged) return [`Check: ${(a.reasons || []).join(", ")}`, WARN];
    return a.classified ? ["Looks OK", OK] : ["Unsorted", ""];
  }
  if (!a.classified) return ["Unsorted", ""];
  if (kind === "urgency") { const [, l, c] = band(URGENCY, a.urgency); return [`${l} · ${a.urgency}`, c]; }
  if (kind === "fit") { const [, l, c] = band(FIT, a.fit); return [`${l} · ${human(a.reason)}`, c]; }
  if (kind === "spam") return a.spam ? [`Spam · ${a.spam_p}`, WARN] : ["Real", OK];
  if (kind === "difficulty") return [human(a.difficulty), PLAIN];
  return [human(kind === "category" ? a.category : a.topic), PLAIN];
};

export const AiTag = ({ ai, kind, testid }) => {
  const [text, cls] = aiTag(ai, kind);
  return <span className={`px-2 py-0.5 rounded-full text-xs font-bold ${cls || "bg-slate-100 text-slate-600 italic"}`} data-testid={testid}>{text}</span>;
};
